import { createActionConst } from '../../../../utils/action.utils';

const WRIKE_NAMESPACE = 'WRIKE';

export const INTEGRATE_WRIKE = createActionConst(WRIKE_NAMESPACE, 'INTEGRATE_WRIKE');
export const FETCH_WRIKE_FOLDERS = createActionConst(WRIKE_NAMESPACE, 'FETCH_WRIKE_FOLDERS');
export const SYNC_WRIKE_FOLDERS = createActionConst(WRIKE_NAMESPACE, 'SYNC_WRIKE_FOLDERS');
export const REMOVE_WRIKE_INTEGRATION = createActionConst(WRIKE_NAMESPACE, 'REMOVE_WRIKE_INTEGRATION');
